<template>
  <div>
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">学生管理</Breadcrumb-item>
        <Breadcrumb-item>课时流水</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div>
      <Form :label-width="100" :show-message="false" label-position="right">
        <Row >
          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="学生" prop="studentKey">
              <Input name="studentKey" v-model="queryParam.studentKey" placeholder="ID/姓名/手机号"></Input>
            </Form-item>
          </Col>
          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="课时来源">
              <Col>
                <Select v-model="queryParam.channel" clearable placeholder="请选择">
                  <Option v-for="item in this.channelList" :value="item.code" :key="item.code">
                    {{ item.text }}
                  </Option>
                </Select>
              </Col>
            </Form-item>
          </Col>
          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="是否加课时">
              <Col>
                <Select v-model="queryParam.addNum" clearable placeholder="请选择">
                  <Option v-for="item in $constant.yesNoNum"
                          :value="item.code" :key="item.code">{{ item.text }}
                  </Option>
                </Select>
              </Col>
            </Form-item>
          </Col>
          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="课时变动时间:">
              <DatePicker @on-change="timeDateChange" format="yyyy-MM-dd" type="daterange" placement="bottom-start"
                          placeholder="选择起始时间" style="width: 100%"></DatePicker>
            </Form-item>
          </Col>
          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="变动原因" prop="remark">
              <Input name="remark" v-model="queryParam.remark" placeholder="上课"></Input>
            </Form-item>
          </Col>
          <Col :xs="12" :sm="12" :md="6">
            <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search" @click="search">搜索
            </Button>
          </Col>
        </Row>
      </Form>
    </div>

    <List
      ref="dataList"
      :tableColumns="tableColumns"
      :reload="reload"
      listUrl="/class-hour/page"
      class="pay-list"
      :params="queryParam"
      :onLoading="onLoading"
      operator=""
    ></List>
  </div>
</template>

<script>
export default {
  data() {
    let $constant = this.$constant
    return {
      searchLoading: false,
      channelList: [],
      loadingWhyNot: false,
      reload: 0,
      queryParam: {
        remark: '',
        channel: '',
        studentKey: '',
        startTime: '',
        endTime: '',
        addNum: ''
      },
      tableColumns: [
        {
          title: '学生ID',
          width: 100,
          align: 'center',
          key: 'uid'
        },
        {
          title: '中(英)文名',
          width: 120,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('div', [
              h('a', {on: {click: () => this.openInfoModal(row.uid)}}, row.nickname),
              h('p', row.enName)
            ])
          }
        },
        {
          title: '课时类型',
          width: 100,
          align: 'center',
          key: 'type'
        },
        {
          title: '课时来源',
          width: 150,
          align: 'center',
          render: (h,params) => {
            let row = params.row
            return [
              h('span', row.channel + '('),
              h('span', { style: { color: 'blue' } }, row.totalNum),
              h('span', ')')]
          }
        },
        {
          title: '变动前',
          width: 100,
          align: 'center',
          key: 'beforeNum'
        },
        {
          title: '变动课时',
          width: 120,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            if (row.addNum) {
              return h('span', { style: { color: 'green' } }, '+' + params.row.num)
            }
            return h('span', { style: { color: 'red' } }, '-' + params.row.num)
          }
        },
        {
          title: '剩余课时',
          width: 100,
          align: 'center',
          key: 'afterNum'
        },
        {
          title: '变动原因',
          width: 200,
          align: 'center',
          key: 'remark'
        },
        {
          title: '时间',
          width: 180,
          align: 'center',
          key: 'gmtCreate'
        },
      ]
    }
  },
  mounted () {
    let self = this
    self.$http.get('/class-hour/channel').then(function (res) {
      if (!res || !res.data) {
        return
      }
      self.channelList = res.data
    })
  },
  methods: {
    timeDateChange(value) {
      let self = this
      self.queryParam.startTime = value[0] + ' 00:00:00'
      self.queryParam.endTime = value[1] + ' 23:59:59'
    },
    onLoading(loading) {
      this.searchLoading = loading
    },
    search() {
      this.reload = new Date().getTime()
    },
    openInfoModal(val) {
      this.uid = val
      let {href} = this.$router.resolve({
        name: 'userPayDetail',
        query: {uid: val, tabName: 0, parm: {id:val}, backPath: '/user/UserPayList'}
      })
      window.open(href, '_blank')
    }
  },

}
</script>




// WEBPACK FOOTER //
// ClassHourFlow.vue?b6d4742c